
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"10"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"data-name":"Ellipse 22","cx":"5","cy":"5","r":"5","fill":"#b1b6b9"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/network_module/hierarchy-treeview/building.svg